import router from './index.js'
import store from '../store/index.js'
import { changeroute } from './routerPermission.js'
import { tim, imInit, IMlogin, TIM } from '@/util/im.js';

const whitelist = [
	'/login',
	'/adminlogin',
	'/arealogin',
	'/agreement',
	'/apply/login',
	'/index/createStore',
	'/index/createStore_user',
	'/register',
	'/forget',
]

const channelpath = ['/channel/wechatmnp']

const role = [83, 80]

router.beforeEach((to, from, next) => {
	let token = sessionStorage.getItem('token')
	let routes = sessionStorage.getItem('routes')
	let pluginroute = sessionStorage.getItem('pluginroute')
	let pluginid = sessionStorage.getItem('pluginid')
	to.meta.keepAlive && store.commit("addIncludeAlive", to.name)
	let path = sessionStorage.getItem("loginPage");
	if (path == '' || path == null) {
		path = '/login'
	}
	if (to.path == '/') {
		next({ path: path });
		return
	}

	let userinfo = JSON.parse(sessionStorage.getItem('userinfo'))
	let IMtoken = sessionStorage.getItem('IMtoken')

	if (IMtoken && userinfo.roles.length > 0 && store.state.ImStatus.imlogin == false) {
		let is_role = role.findIndex(item => {
			return item == userinfo.roles[0].id
		})

		if (is_role != -1) {
			imInit(1400635745, 0)
		}
	}

	if (token && routes) {
		let routeadds = store.state.routeadds
		if (routeadds == 0) {
			if (pluginroute && channelpath.indexOf(to.path) == -1) {
				router.addRoutes(changeroute(JSON.parse(pluginroute)))
				store.commit('pluginrouteadd', pluginid)
			} else {
				router.addRoutes(changeroute(JSON.parse(routes)))
			}
			next({ ...to, replace: true })
		} else {
			next()
		}
	} else {
		if (whitelist.indexOf(to.path) != -1) {
			next()
		} else {
			let path = sessionStorage.getItem("loginPage");
			if (path == '' || path == null) {
				path = '/login'
			}
			if (to.path == '/') {
				next({ path: path });
				return
			}
			next({ path: path })
		}
	}
});
